<template>
  <a-row>
    <a-col :span="labelCol">
      <div class="label-title">{{title}}</div>
    </a-col>
    <a-col :span="valueCol">
      <a-form-item v-bind="validate" :extra="extra">
        <a-input-number v-model:value="inputValue" :disabled="disabled" @change="onChange" :min="min" :max="max" />
        <span v-if="validate" class="must">*</span>
      </a-form-item>
    </a-col>
  </a-row>
</template>

<script>
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
  props: {
    value: {
      type: Number,
      default: 0
    },

    title: {
      type: String,
      default: '标题'
    },

    extra: {
      type: String,
      default: ''
    },

    labelCol: {
      type: Number,
      default: 10
    },

    valueCol: {
      type: Number,
      default: 12
    },

    validate: {
      type: Object,
      default: () => null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    after: {
      type: String,
      default: ''
    },
    min: {
      type: Number,
      default: -999999999
    },
    max: {
      type: Number,
      default: 999999999
    }
  },
  emits: ['ok', 'update:value'],
  setup (props, { emit }) {
    const inputValue = ref(props.value)

    watch(props, e => {
      inputValue.value = e.value
    })

    const onChange = e => {
      emit('ok', e)
      emit('update:value', e)
    }

    return {
      inputValue,
      onChange
    }
  }
})
</script>

<style lang="less" scoped>
  .must{
    position: relative;
    top: 3px;
    left: 3px;
    color: #f00;
    font-size: 18px;
    line-height: 32px;
  }
  .after{
    position: absolute;
    bottom: 0;
    right: -16px;
    font-size: 12px;
  }
</style>
